import ComposeViewState from '../store/schema/ComposeViewState';
import Message from 'owa-service/lib/contract/Message';
import setAppendOnSendExtendedPropertiesToMessage from './setAppendOnSendExtendedPropertiesToMessage';
import removeExtendedPropertiesFromMessage from './removeExtendedPropertiesFromMessage';

export default function tryUpdateExtendedPropertiesForAppendOnSend(
    viewState: ComposeViewState,
    messageType: Message,
    isSend: boolean
) {
    if (isSend) {
        removeExtendedPropertiesFromMessage(['AppendOnSend'], messageType);
    } else if (viewState.appendOnSend && viewState.appendOnSend.length > 0) {
        // it is a save, not a send
        setAppendOnSendExtendedPropertiesToMessage(viewState.appendOnSend, messageType);
    }
}
